// Vendors
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BulkStatusChange = ({
  projects,
  adminFilters: { builder },
  handleUpdateProjectStatuses,
  setMainNotice
}) => {
  const [bulkStatus, setBulkStatus] = useState('Active');
  const [bulkMessage, setBulkMessage] = useState('');
  const [selectedProjectIDs, setSelectedProjectIDs] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSelectProject = (pid) => {
    if (!pid) return;

    let newArr = [...selectedProjectIDs];

    // if id is already present in array, remove from array.
    if (newArr.includes(pid)) {
      newArr = selectedProjectIDs.filter((id) => id !== pid);
    } else {
      // else add.
      newArr.push(pid);
    }

    setSelectedProjectIDs(newArr);
  };

  const handleBulkUpdateStatus = () => {
    if (!selectedProjectIDs.length) return;

    setLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_pip_set_bulk_status');
    formData.append('status', bulkStatus);
    formData.append('message', bulkMessage);
    formData.append('pids', selectedProjectIDs);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        const { message } = data;

        setLoading(false);

        if (success) {
          const { pids, status } = data;
          resetBulkChangeState();
          handleUpdateProjectStatuses(pids, status);
        }

        setMainNotice({
          type: success ? 'success' : 'error',
          message: message
        });
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });
        setShowMainNotice(true);

        setLoading(false);
      });
  };

  const resetBulkChangeState = () => {
    setSelectedProjectIDs([]);
    setBulkStatus('Active');
    setBulkMessage('');
  };

  useEffect(() => {
    if (builder == 0) resetBulkChangeState();
  }, []);

  return (
    <>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-top-0 u--margin-bottom-20" />
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-4 u--padding-top-0">
        {Object.values(projects).map(({ pid, address, status }) => {
          return (
            <label
              key={pid}
              className="form__checkbox form__checkbox--sm u--margin-top-0"
            >
              <input
                type="checkbox"
                name="project_id"
                checked={selectedProjectIDs.includes(pid)}
                onChange={() => {
                  handleSelectProject(pid);
                }}
              />{' '}
              {address} - [{status}]
            </label>
          );
        })}
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-8 u--padding-top-0">
        <div className="form__field u--margin-bottom-20">
          <div className="form__select form__select--xs">
            <select
              className="form__input form__input--xs"
              defaultValue={bulkStatus}
              onChange={(event) => setBulkStatus(event.target.value)}
              disabled={loading}
            >
              {Array.from([
                'Active',
                'Submitted',
                'Incomplete',
                'Approved',
                'Completed'
              ]).map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form__field u--margin-bottom-20">
          <textarea
            type="textarea"
            className="form__textarea form__textarea--sm"
            placeholder={`(Send additional message to${
              selectedProjectIDs.length > 1
                ? ` ${selectedProjectIDs.length}`
                : ''
            } selected ${
              selectedProjectIDs.length === 1 ? 'project' : 'projects'
            } with this status change.)`}
            value={bulkMessage}
            onChange={(event) => setBulkMessage(event.target.value)}
            disabled={loading}
          />
        </div>
        <button
          className={`btn btn--xs btn--green ${
            loading === true ? 'btn--loading' : ''
          }`}
          type="button"
          onClick={() => handleBulkUpdateStatus()}
          disabled={selectedProjectIDs.length === 0 || loading === true}
        >
          <span className="btn__content">
            <span className="btn__text">Bulk Update Status</span>
          </span>
        </button>
      </div>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-0" />
      </div>
    </>
  );
};

export default BulkStatusChange;
